
import { RevButtonTiny, openModal } from '@backmarket/design-system'
import isEmpty from 'lodash/isEmpty'
import { mapGetters } from 'vuex'

import { MODAL_NAMES } from '@config/constants'

import {
  CATEGORIES_WITH_HIGHLIGHTED_TECH_SPECS,
  HIGHLIGHTED_TECH_SPECS,
} from './TechnicalSpecifications.constants'
import translations from './TechnicalSpecifications.translations'

export default {
  components: {
    RevButtonTiny,
  },

  props: {
    product: {
      type: Object,
      required: true,
    },
    technicalSpecifications: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters({
      experiments: 'experiments/getExperiments',
    }),

    translations: () => translations,

    categoryId() {
      return this.product.trackingDetails.category3MarketplaceCategory_ID
    },

    showTechnicalSpecifications() {
      if (this.experiments.ppTechSpecsVisibility !== 'ppTechSpecsHighlighted') {
        return false
      }

      if (!CATEGORIES_WITH_HIGHLIGHTED_TECH_SPECS.includes(this.categoryId)) {
        return false
      }

      if (isEmpty(this.technicalSpecifications)) {
        return false
      }

      if (!this.highlightedSpecifications.length) {
        return false
      }

      return true
    },

    highlightedSpecifications() {
      const specs = HIGHLIGHTED_TECH_SPECS[this.categoryId]

      return specs.reduce((acc, keys) => {
        const apiSpec = this.technicalSpecifications.specifications.filter(
          (s) => keys.includes(s.field),
        )

        if (apiSpec.length === keys.length) {
          // Let's reorder the spec to match what we have in the config
          const orderedSpecs = keys.map((key) =>
            apiSpec.find((s) => s.field === key),
          )

          return [
            ...acc,
            {
              // Let's get the first spec title (ex: processor + processor_speed: we just display "Processor")
              title: orderedSpecs[0].display,
              // Concatenate the values (ex: processor + processor_speed: "Core i5-8210Y 1.6 GHz" )
              value: orderedSpecs.map((spec) => spec.values[0].label).join(' '),
            },
          ]
        }

        return acc
      }, [])
    },
  },

  methods: {
    openTechSpecModal: () => {
      openModal(MODAL_NAMES.PRODUCT.TECH_SPECS)
    },
  },
}
